// eslint-disable-next-line @typescript-eslint/consistent-type-imports
let inspect = undefined;
try {
    // eslint-disable-next-line unicorn/prefer-top-level-await
    void import("util").then((mod) => {
        inspect = mod.inspect;
    });
}
catch {
    // ignore
}
export function debugStringify(value, colors = false, useGetters = false) {
    if (inspect) {
        return inspect(value, {
            depth: 10,
            colors,
            compact: false,
            getters: useGetters,
            numericSeparator: true,
        });
    }
    if (typeof value === "object" && !(value instanceof Error)) {
        if (value === null) {
            return "[null]";
        }
        try {
            const cache = new Set();
            return JSON.stringify(value, (_key, value) => {
                if (value !== null && typeof value === "object") {
                    // Duplicate reference found, discard key
                    if (cache.has(value))
                        return;
                    // Store value in our collection
                    cache.add(value);
                }
                return value;
            }, 2);
        }
        catch {
            return String(value);
        }
    }
    else {
        switch (typeof value) {
            case "undefined": {
                return "[undefined]";
            }
            case "function": {
                return `[function: ${value.name}]`;
            }
            default: {
                return String(value);
            }
        }
    }
}
//# sourceMappingURL=debugStringify.js.map